import "./ApPayment.scss";
import AllDocsNote from "../../../components/allDocsNote/AllDocsNote.jsx";
import AllFiles from "../../../components/allFiles/AllFiles.jsx";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, {
  CustomButtonSmall,
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { showToast } from "../../../toastService.js";
import { fetchClientsBySearch, fetchMainLedgers, fetchSubLedgers, formatAmountsToDecimals, formatStringToNumberV2, getCssValue, logData, numberToWordsWithDecimal } from "../../../utils/genericFunctions.js";
import newRequest from "../../../utils/newRequest.js";
import AddIcon from "@mui/icons-material/Add";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import RefreshIcon from "@mui/icons-material/Refresh";
import Big from "big.js";
import moment from "moment";
import numeral from "numeral";
import { useEffect, useState } from "react";
import Confetti from "react-confetti";
import { FaSave } from "react-icons/fa";
import { IoChatbubbles, IoCheckmarkDoneOutline, IoClose, IoDocumentTextSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { GridLoader, ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import Badge from '@mui/material/Badge';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent
} from "@mui/material";
import FileUploadComponent from "../../../components/fileUploadComponent/FileUploadComponent.jsx";
import ValidationMessages from "../../../components/validationMessages/ValidationMessages.jsx";
import DOMPurify from 'dompurify';
import EmailComponent from "../../../components/emailComponent/EmailComponent.jsx";
import Correspondence from "../../../components/correspondence/Correspondence.jsx";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import TagIcon from '@mui/icons-material/Tag';
import { TbCertificate } from "react-icons/tb";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import Invoice from "../../../components/test/Invoice.jsx";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { FiSearch } from "react-icons/fi";
import { MdAdd, MdClose, MdDelete, MdEditDocument, MdEmail, MdOutlineNumbers, MdPhone, MdSms, MdForum, MdAlternateEmail } from "react-icons/md";
import { useTranslation } from "react-i18next";
import Taccount from "../../../components/taccount/Taccount.jsx";
import { HiOutlineLink } from "react-icons/hi2";
import { RiAttachment2 } from "react-icons/ri";
import { useRef } from "react";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar.jsx";
import { CustomRadioGroup } from "../../../components/radio/CustomRadioGroup.jsx";
import Collaborator from "../../../components/Collaborator/Collaborator.jsx";

const ApPayment = () => {
  const { t } = useTranslation();
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isCollabOpen, setIsCollabOpen] = useState(false);
  const openCollab = () => setIsCollabOpen(true);
  const closeCollab = () => setIsCollabOpen(false);
  const pageShellRef = useRef(null);
  const [collabRightOffset, setCollabRightOffset] = useState(0);
  const [traceData, setTraceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [figuresToShow, setFiguresToShow] = useState("org");
  const navigate = useNavigate();
  const { docid } = useParams();
  const [paymentDocId, setPaymentDocId] = useState(null);
  const clientRef = useRef(null);
  const miscNameRef = useRef(null);
  const payingForRef = useRef(null);
  const [paymentData, setPaymentData] = useState(null);

  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [emailData, setEmailData] = useState(null);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);

  const [documentEnabled, setDocumentEnabled] = useState("Y");
  const [nextAction, setNextAction] = useState("Validate");
  const [summaryCurrentView, setSummaryCurrentView] = useState("summary");
  const [isConfettiActive, setIsConfettiActive] = useState(false);
  const [validationMsgDialog, setValidationMsgDialog] = useState(false);
  const [validationMessagesResult, setValidationMessagesResult] = useState({});
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
    amount: 0
  });
  const [invokedAction, setInvokedAction] = useState("");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [maxMatchFcAmount, setMaxMatchFcAmount] = useState();
  const [maxMatchLcAmount, setMaxMatchLcAmount] = useState();

  const [numGeneration, setNumGeneration] = useState({});
  let generatedDocNo = "";
  let isDocumentNumberSetup = false;
  const [hdNo, setHdNo] = useState(null);
  const [hdCurCode, setHdCurCode] = useState({
    value: "",
    label: "",
  });
  const [hdCurRate, setHdCurRate] = useState(1);
  const [currencies, setCurrencies] = useState([]);
  const [hdNarration, setHdNarration] = useState(null);
  const [hdRefNo, setHdRefNo] = useState(null);
  const [hdAcNo, setHdAcNo] = useState(null);
  const [hdType, setHdType] = useState("Normal");
  const [bankAccounts, setBankAccounts] = useState([]);
  const [hdBizUnit, setHdBizUnit] = useState(null);
  const [branches, setBranches] = useState([]);
  const [hdGlDate, setHdGlDate] = useState(null);
  const [hdMode, setHdMode] = useState(null);
  const [paymentMode, setPaymentMode] = useState([]);
  const [hdStatus, setHdStatus] = useState("New");
  const [hdPayingFor, setHdPayingFor] = useState(null);
  const [payingFor, setPayingFor] = useState([]);
  const [hdAentCode, setHdAentCode] = useState(null);
  const [hdEntCode, setHdEntCode] = useState(null);
  const [hdChqNo, setHdChqNo] = useState(null);
  const [hdChqBank, setHdChqBank] = useState(null);
  const [hdChqDate, setHdChqDate] = useState(null);
  const [hdFcAmount, setHdFcAmount] = useState("");
  const [hdLcAmount, setHdLcAmount] = useState("");

  const [hdMiscName, setHdMiscName] = useState("");
  const [hdMiscEmail, setHdMiscEmail] = useState("");
  const [hdMiscPhone, setHdMiscPhone] = useState("");
  const [hdMiscIdnumber, setHdMiscIdnumber] = useState("");
  const [hdMglCode, setHdMglCode] = useState(null);
  const [hdMglSubType, setHdMglSubType] = useState(null);
  const [hdSglCode, setHdSglCode] = useState(null);
  const [hdMiscTaxPin, setHdMiscTaxPin] = useState("");
  const [hdMiscRefNo, setHdMiscRefNo] = useState("");

  const [hdWhichYear, setHdWhichYear] = useState(null);
  const [hdWhichPeriod, setHdWhichPeriod] = useState(null);
  const [payingYears, setPayingYears] = useState([]);
  const [payingPeriods, setPayingPeriods] = useState([]);

  const [allocatedFcAmountXx, setAllocatedFcAmountXx] = useState(0);
  const [allocatedLcAmountXx, setAllocatedLcAmountXx] = useState(0);
  const [netoffCommission, setNetoffCommission] = useState("Y");
  const [matchedFcAmount, setMatchedFcAmount] = useState();
  const [matchedLcAmount, setMatchedLcAmount] = useState();
  const [matchedCommFc, setMatchedCommFc] = useState();
  const [matchedCommLc, setMatchedCommLc] = useState();

  const [controlPremiumFc, setControlPremiumFc] = useState();
  const [controlPremiumLc, setControlPremiumLc] = useState();
  const [controlCommissionFc, setControlCommissionFc] = useState();
  const [controlCommissionLc, setControlCommissionLc] = useState();
  const [isSearchDialogOpened, setIsSearchDialogOpened] = useState(false);
  const [searchTermClaim, setSearchTermClaim] = useState("");
  const [entityClaims, setEntityClaims] = useState([]);
  const [selectedClaim, setSelectedClaim] = useState(null);
  const [rowsPerPageClaims, setRowsPerPageClaims] = useState(6);
  const [currentClaimPage, setCurrentClaimPage] = useState(0);
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const [paymentsToRemit, setReceiptsToRemit] = useState([]);
  const [paymentLines, setPaymentLines] = useState([]);
  const [selectedPaymentLine, setSelectedPaymentLine] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const [installments, setInstallments] = useState([]);


  const handleClaimPageChange = (event, newPage) => {
    setCurrentClaimPage(newPage);
  };

  const handleClaimRowsPerPage = (event) => {
    setRowsPerPageClaims(parseInt(event.target.value, 10));
    setCurrentClaimPage(0);
  };


  const filteredClaims = entityClaims?.filter(
    (row) =>
      row?.cm_no?.toLowerCase().includes(searchTermClaim.toLowerCase()) ||
      row?.cm_remarks?.toLowerCase().includes(searchTermClaim.toLowerCase()) ||
      row?.cm_facility_ref_no?.toLowerCase().includes(searchTermClaim.toLowerCase()) ||
      row?.cm_member_ent_code?.toLowerCase().includes(searchTermClaim.toLowerCase()) ||
      row?.cm_search_params?.toLowerCase().includes(searchTermClaim.toLowerCase())
  );

  const paginatedClaims = filteredClaims?.slice(
    currentClaimPage * rowsPerPageClaims,
    currentClaimPage * rowsPerPageClaims + rowsPerPageClaims
  );


  // end of payment fields
  //lines


  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setCurrentPage(0);
  };
  // attachments
  const [attachmentsData, setAttachmentsData] = useState([]);

  const slicedPaymentLines = paymentLines.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const customNoOptionsMessage = (customMessage) => {
    return (
      <span
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1 className="sub-title" >
          {customMessage}
        </h1>
        <CustomButtonSmall
          onClick={() => navigate("/entity/new")}
        >
          {t('create')}
        </CustomButtonSmall>
      </span>
    );
  };

  const fetchPaymentLines = async (paymentDocid) => {
    try {
      const res = await newRequest.post("/apPaymentLn/findAll", { ln_hd_no_docid: paymentDocid });
      const formattedLines = res.data?.map(line => ({
        ...line,
        ln_fc_amount: formatAmountsToDecimals(line?.ln_fc_amount, 2),
        ln_lc_amount: formatAmountsToDecimals(line?.ln_lc_amount, 2),
      }));
      setPaymentLines(formattedLines);
      // console.log(`setPaymentLines  ${JSON.stringify(res.data, null, 2)}`);
    } catch (err) {
      console.log(err);
    }
  };


  const fetchReceiptsToRemit = async (entCode) => {
    try {
      // if (entCode) {
      //   const res = await newRequest.post("/apPaymentLn/paymentsToRemit", { carrier_ent_code: entCode });
      //   const options = res.data.map((rn) => ({
      //     ln_hd_no: rn?.ln_hd_no,
      //     ln_hd_no_docid: rn?.ln_hd_no_docid,
      //     ln_paying_for: rn?.ln_paying_for,
      //     ln_doc_type: rn?.ln_doc_type,
      //     ln_doc_no: rn?.ln_doc_no,
      //     ln_doc_docid: rn?.ln_doc_docid,
      //     ln_doc_ins_no: rn?.ln_doc_ins_no,
      //     ln_fc_amount: rn?.ln_fc_amount,
      //     ln_lc_amount: rn?.ln_lc_amount,
      //     ln_ent_code: rn?.ln_ent_code,
      //     ln_insured_ent_code: rn?.ln_insured_ent_code,
      //     ln_carrier_ent_code: rn?.ln_carrier_ent_code,
      //     main_narration_xx: rn?.main_narration_xx,
      //     sub_narration_xx: rn?.sub_narration_xx,
      //     remitted_amount_fc: rn?.remitted_amount_fc,
      //     remitted_amount_lc: rn?.remitted_amount_lc,
      //     os_to_remit_amount_fc: rn?.os_to_remit_amount_fc,
      //     os_to_remit_amount_lc: rn?.os_to_remit_amount_lc,
      //     value: `${t('payment')} : ${rn?.ln_hd_no} - ${t('noteNo')} : ${rn?.ln_doc_no}`,
      //     label: `${t('payment')} : ${rn?.ln_hd_no} - ${t('noteNo')} : ${rn?.ln_doc_no}`,
      //   }));
      //   // console.log(`setEntityRiskNotes ${JSON.stringify(options, null, 2)}`);
      //   setReceiptsToRemit(options);
      // }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTrace = async (paymentNo) => {
    try {
      const res = await newRequest.post(
        "/trace/findDoc",
        {
          trc_doc_type: "AP Payment",
          trc_doc_no: paymentNo
        }
      );
      setTraceData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchClaims = async () => {
    try {
      setIsProcessing(true);
      setEntityClaims([]);
      const res = await newRequest.post("/meds/findAll",
        {
          facilities_ent_codes: [hdEntCode?.value],
          claim_statuses: ["Awaiting Payment", "Partially Paid"],
        });
      setEntityClaims(res.data);
      setIsProcessing(false);
    } catch (error) {
      setIsProcessing(false);
    }
  };

  const handleMatchedFcAmountBlur = (e) => {
    if (e.target.value) {
      const strippedValue = e.target.value.replace(/,/g, "");
      if (isNaN(strippedValue)) {
        setMatchedFcAmount("0.00")
        setNotifyDialogTitle("Error!");
        setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
        setIsNotifyDialogOpen(true); return;
      }

      console.log(`strippedValue ... ${strippedValue} float ${parseFloat(strippedValue)}`);
      console.log(`maxMatchFcAmount ... ${maxMatchFcAmount} float ${parseFloat(maxMatchFcAmount)}`);

      if (parseFloat(strippedValue) > parseFloat(maxMatchFcAmount)) {
        setMatchedFcAmount(maxMatchFcAmount)
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(
          `You cannot match amount greater than received amount of ${numeral(maxMatchFcAmount).format("0,0.00")}!`
        );
        setIsNotifyDialogOpen(true);
        return;
      } else {
        setMatchedFcAmount(formatAmountsToDecimals(strippedValue, 2));
        const lcAmount = Number(parseFloat(strippedValue * hdCurRate).toFixed(4));
        setMatchedLcAmount(lcAmount);
      }
    }
  };

  const handleMatchedCommFcBlur = (e) => {
    if (e.target.value) {
      const strippedValue = e.target.value.replace(/,/g, ""); // Remove commas
      const parsedValue = Big(strippedValue); // Use big.js to handle the value

      // Check if the parsed value is NaN
      if (!parsedValue.eq(parsedValue)) {
        setMatchedCommFc("");
      } else {
        // Format the parsed value with 2 decimal places and digit grouping
        const formattedValue = parsedValue
          .toFixed(2)
          .toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        setMatchedCommFc(formattedValue);

        const lcAmount = Number(parseFloat(parsedValue * hdCurRate).toFixed(4));
        setMatchedCommLc(lcAmount);
      }
    }
  };

  const handleFcAmountBlur = (e) => {
    try {
      if (e.target.value) {
        const strippedValue = e.target.value.replace(/,/g, ""); // Remove commas
        if (isNaN(strippedValue)) {
          setNotifyDialogTitle("Error!");
          setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
          setIsNotifyDialogOpen(true);
          return;
        }

        const parsedValue = Big(strippedValue); // Use big.js to handle the value

        // Check if the parsed value is NaN
        if (!parsedValue.eq(parsedValue)) {
          setHdFcAmount("");
        } else {
          setHdFcAmount(formatAmountsToDecimals(parsedValue, 2));
          const lcAmount = Number(parseFloat(parsedValue * hdCurRate).toFixed(4));
          setHdLcAmount(lcAmount);
        }
      }
    } catch (error) {
      console.log(error)
    }
  };

  const handleGlDateChange = async (e) => {
    try {
      if (e.target.value) {
        const formattedGlDate = moment(e.target.value).format("YYYY-MM-DD");
        setHdGlDate(formattedGlDate);
        if (hdCurCode.value !== currentUser.currency_code_xx) {
          // get rate
          const res = await newRequest.post(
            "/glCurrencyRate/find",
            {
              rate_cur_code_fm: hdCurCode.value,
              rate_cur_code_to: currentUser.currency_code_xx,
              rate_date: formattedGlDate,
            }
          );
          if (!res.data || !res.data?.rate) {
            setHdCurCode({
              value: currentUser.currency_code_xx,
              label: currentUser.currency_name_xx,
            });
            setHdCurRate(1);
            setNotifyDialogTitle("Note!");
            setNotifyDialogText(
              `Conversion Rate from <strong>${hdCurCode?.value
              } to ${currentUser.currency_code_xx
              } for date ${moment(hdGlDate).format(
                "DD-MMM-YYYY"
              )}</strong> NOT found. Currency will reset to <strong>${currentUser.currency_code_xx
              }</strong>`
            );
            setIsNotifyDialogOpen(true);
          } else {
            setHdCurRate(res.data.rate);
          }
        } else {
          setHdCurRate(1);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };


  const fetchPayment = async (doc_id, firstTime = false) => {
    try {

      if (doc_id && doc_id !== "new") {
        if (firstTime) {
          setIsLoading(true);
        }

        const res = await newRequest.get(`/apPaymentHdr/findById/${doc_id}`);

        if (res.data) {
          setPaymentData(res.data);
          setPaymentDocId(res.data._id);

          if (res.data?.hd_no) {
            setHdNo(res.data?.hd_no);
          }

          if (res.data?.hd_type) {
            setHdType(res.data?.hd_type);
          }

          if (res.data?.hd_status) {
            setHdStatus(res.data?.hd_status);
          }
          if (res.data?.hd_cur_rate) {
            setHdCurRate(res.data?.hd_cur_rate);
          }
          if (res.data?.hd_narration) {
            setHdNarration(res.data?.hd_narration);
          }
          if (res.data?.hd_ref_no) {
            setHdRefNo(res.data?.hd_ref_no);
          }
          if (res.data?.hd_chq_no) {
            setHdChqNo(res.data?.hd_chq_no);
          }
          if (res.data?.hd_chq_bank) {
            setHdChqBank(res.data?.hd_chq_bank);
          }

          if (res.data?.hd_chq_date) {
            const formattedChqDate = moment(res.data?.hd_chq_date).format(
              "YYYY-MM-DD"
            );
            setHdChqDate(formattedChqDate);
          }

          if (res.data?.hd_fc_amount) {
            const formattedValue = formatAmountsToDecimals(res.data?.hd_fc_amount);
            setHdFcAmount(formattedValue)
          }

          if (res.data?.hd_lc_amount) {
            setHdLcAmount(res.data?.hd_lc_amount);
          }

          if (res.data?.hd_biz_unit) {
            setHdBizUnit({
              value: res.data?.hd_biz_unit,
              label: res.data.bizunit_name_xx,
            });
          }

          if (res.data?.hd_gl_date) {
            const formattedGlDate = moment(res.data?.hd_gl_date).format(
              "YYYY-MM-DD"
            );
            setHdGlDate(formattedGlDate);
          }

          if (res.data?.hd_cur_code) {
            setHdCurCode({
              value: res.data?.hd_cur_code,
              label: res.data.currency_xx,
            });
          }

          if (res.data?.hd_mode) {
            setHdMode({
              value: res.data?.hd_mode,
              label: res.data.payment_mode_xx,
            });
          }

          if (res.data?.hd_paying_for) {
            setHdPayingFor({
              value: res.data?.hd_paying_for,
              label: res.data.paying_for_xx,
            });
          }

          if (res.data?.hd_which_year) {
            setHdWhichYear({
              value: res.data?.hd_which_year,
              label: res.data?.hd_which_year,
            });
          }

          if (res.data?.hd_which_period) {
            setHdWhichPeriod({
              value: res.data?.hd_which_period,
              label: res.data?.hd_which_period,
            });
          }

          if (res.data.bank_ac_no_xx) {
            setHdAcNo({
              bank_code: res.data.bank_code_xx,
              branch_code: res.data.bank_branch_code_xx,
              value: res.data.bank_ac_no_xx,
              label: res.data.bank_ac_name_xx,
            });
          }

          if (res.data?.hd_ent_code) {
            setHdEntCode({
              ent_email: res.data.client_details_xx.ent_email,
              ent_phone_no: res.data.client_details_xx.ent_phone_no,
              ent_photo_url: res.data.client_details_xx.ent_photo_url,
              ent_status: res.data.client_details_xx.ent_status,
              aent_name_xx: res.data.client_details_xx.aent_name_xx,
              ent_code: res.data?.hd_ent_code,
              ent_aent_code: res.data?.hd_aent_code,
              ent_name: res.data.client_details_xx.ent_name,
              value: res.data?.hd_ent_code,
              label: res.data.client_details_xx.ent_name,
            });
          }

          // Miscellanous payment detailts
          setHdMiscName(res.data?.hd_misc_name);
          setHdMiscEmail(res.data?.hd_misc_email);
          setHdMiscPhone(res.data?.hd_misc_phone);
          setHdMiscIdnumber(res.data?.hd_misc_idnumber);
          setHdMiscTaxPin(res.data?.hd_misc_tax_pin);
          setHdMiscRefNo(res.data?.hd_misc_ref_no);
          setHdMglSubType(res.data?.hd_mgl_sub_type);

          if (res.data?.hd_mgl_code) {
            setHdMglCode({
              value: res.data?.hd_mgl_code,
              label: res.data?.hd_mgl_code_xx
            });
          } else {
            setHdMglCode(null);
          }

          if (res.data?.hd_sgl_code) {
            setHdSglCode({
              value: res.data?.hd_sgl_code,
              label: res.data?.hd_sgl_code_xx
            });
          } else {
            setHdSglCode(null);
          }

          // setAllocatedFcAmountXx(res.data.allocated_fc_amount_xx);
          // setAllocatedLcAmountXx(res.data.allocated_lc_amount_xx);

          setDocumentEnabled(res.data.document_enabled_xx);
          setNextAction(res.data.next_action_xx);
          await fetchTrace(res.data?.hd_no);
          await fetchPaymentLines(res.data._id);
          await fetchReceiptsToRemit(res.data?.hd_ent_code);
        }
        // fetch attachments
        fetchDocumentAttachments("AP Payment", res.data._id);
      }
    } catch (err) {
      console.log(err);
    } finally {
      if (firstTime) {
        setIsLoading(false);
      }
    }
  };

  const fetchBranches = async () => {
    try {
      const res = await newRequest.post("/orgUnit/findAll", { unit_status: "Active" });
      const options = res.data.map((branch) => ({
        value: branch.unit_code,
        label: branch.unit_name,
      }));
      setBranches(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const res = await newRequest.get("/glCurrency/findAll");
      const options = res.data.map((currency) => ({
        value: currency.cur_code,
        label: currency.cur_name,
      }));
      setCurrencies(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchBankAccounts = async () => {
    try {
      const res = await newRequest.get("/glBankAc/findAll");
      // console.log(`res  ${JSON.stringify(res.data, null, 2)}`);
      // Filter the bank accounts based on the specified conditions
      const filteredAccounts = res.data.filter((bank) =>
        bank?.ac_status === "Active" &&
        bank?.ac_visible === "Y" &&
        bank?.ac_pay === "Y"
      );

      // Map the filtered accounts to the desired options format
      const options = filteredAccounts.map((bank) => ({
        bank_code: bank?.bank_code_xx,
        branch_code: bank?.bank_branch_code_xx,
        value: bank?.ac_no,
        label: bank?.ac_name,
      }));

      setBankAccounts(options);

      if (paymentDocId === "new") {
        setHdAcNo({
          bank_code: filteredAccounts[0]?.bank_code_xx,
          branch_code: filteredAccounts[0]?.bank_branch_code_xx,
          value: filteredAccounts[0]?.ac_no,
          label: filteredAccounts[0]?.ac_name,
        });
      }
    } catch (error) {
      console.error("Error fetching bank accounts :", error);
    }
  };

  // fetch number generation code
  const fetchNumberGeneration = async () => {
    try {
      const res = await newRequest.post(
        "/orgNumgen/find",
        {
          gen_org_code: currentUser.usr_org_code,
          gen_type: "Payment",
        }
      );
      setNumGeneration(res.data);
      isDocumentNumberSetup = true;
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDocumentAttachments = async (docType, docid) => {
    try {
      const res = await newRequest.post(
        "/files/findDocFiles",
        {
          fl_doc_type: docType,
          fl_parent_doc_id: docid,
        }
      );

      setAttachmentsData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchPaymentMode = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Payment Mode" }
      );
      const options = res.data.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setPaymentMode(options);
    } catch (error) {
      console.error("Error fetching payment modes :", error);
    }
  };

  const fetchPayingFor = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Paying For" });
      const options = res.data.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setPayingFor(options);
    } catch (error) {
      console.error("Error fetching payment modes :", error);
    }
  };

  // generate document number
  const generateDocumentNo = async () => {
    try {
      const res = await newRequest.post("/orgNumgen/gen", { gen_type: "Payment" });
      generatedDocNo = res.data;
    } catch (err) {
      console.log(err);
    }
  };

  const handleConfettiClick = () => {
    setIsConfettiActive(true);
    // Set a timeout to stop the confetti after a few seconds (optional)
    setTimeout(() => {
      setIsConfettiActive(false);
    }, 3000); // Stop confetti after 3 seconds
  };



  const handleConfirm = async () => {
    try {

      if (confirmDialogAction === "paymentAction") {

        if ((formatStringToNumberV2(hdFcAmount) - allocatedFcAmountXx) < 0) {
          setIsConfirmDialogOpen(false);
          setConfirmDialogAction("None");
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(
            `You cannot allocate more than <b>${hdCurCode?.value} ${numeral(formatStringToNumberV2(hdFcAmount)).format("0,0.00")}</b>. You cannot proceed.`
          );
          setIsNotifyDialogOpen(true);
          return;
        }

        // check if period is open
        const formattedGlDate = moment(hdGlDate).format("YYYY-MM-DD");
        const res = await newRequest.post(
          "/glCp/periodStatus",
          {
            cp_cy_type: "Financial",
            gl_date: formattedGlDate,
          },
        );

        if (res.data.cp_status === "Closed") {
          setIsConfirmDialogOpen(false);
          setConfirmDialogAction("None");
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(
            `Accounting date ${moment(hdGlDate).format(
              "DD-MMM-YYYY"
            )} is within Financial period ${res.data.cp_code
            }. The period is ${res.data.cp_status}. You cannot proceed.`
          );
          setIsNotifyDialogOpen(true);
          return;
        }

        if (["Investment", "Premium"].includes(hdPayingFor?.value) && formatStringToNumberV2(hdFcAmount) !== formatStringToNumberV2(allocatedFcAmountXx)) {
          setIsProcessing(false);
          setIsConfirmDialogOpen(false);
          setNotifyDialogTitle(t('error'));
          setNotifyDialogText(`${t('allocationBalanceError', { param1: hdPayingFor?.value, param2: `${hdCurCode?.value} : ${numeral(allocatedFcAmountXx).format("0,0.00")}`, param3: numeral(hdFcAmount).format("0,0.00") })}`);
          setIsNotifyDialogOpen(true);
          return;
        }

        setIsProcessing(true);
        if (["Approved", "Validated"].includes(objectToAction.new_doc_status)) {
          // do all validations
          let validateResponse = null;
          try {
            validateResponse = await newRequest.get(`/apPaymentHdr/validate/${paymentDocId}`, { timeout: 100000 });
          } catch (error) {
            setIsProcessing(false);
            if (error.code === 'ECONNABORTED') {
              console.error("Request timed out!");
              showToast(t('requestTimedOut'), "error");
            } else {
              console.error("Other error:", error.message);
              showToast(error.message, "error");
            }
          }

          if (validateResponse.data.result_status === "error") {
            setIsProcessing(false);
            setIsConfirmDialogOpen(false);
            setValidationMessagesResult(validateResponse.data);
            setValidationMsgDialog(true);
            return;
          }
        } else if (["Cancelled"].includes(objectToAction.new_doc_status)) {
          // do all validations
          let validateResponse = null;
          try {
            validateResponse = await newRequest.get(`/apPaymentHdr/reversePayment/${paymentDocId}`, { timeout: 100000 });
          } catch (error) {
            setIsProcessing(false);
            if (error.code === 'ECONNABORTED') {
              console.error("Request timed out!");
              showToast(t('requestTimedOut'), "error");
            } else {
              console.error("Other error:", error.message);
              showToast(error.message, "error");
            }
          }

          if (validateResponse.data.result_status === "error") {
            setIsProcessing(false);
            setIsConfirmDialogOpen(false);
            setValidationMessagesResult(validateResponse.data);
            setValidationMsgDialog(true);
            return;
          }
        }

        await newRequest.put(`/apPaymentHdr/upd/${paymentData._id}`, { hd_status: objectToAction?.new_doc_status });

        try {
          await newRequest.post(
            "/trace/add",
            {
              trc_action_on: "Document",
              trc_doc_type: "Payment",
              trc_doc_no: paymentData.hd_no,
              trc_doc_docid: paymentDocId,
              trc_aent_code: "",
              trc_ent_code: "",
              trc_action: "updated document status",
              trc_remarks: `updated payment to ${objectToAction?.new_doc_status}`,
              trc_tags: [`updated payment to ${objectToAction?.new_doc_status}`],
            },

          );
        } catch (error) {
          console.log(error);
        }

        try {
          await newRequest.post(
            "/trace/add",
            {
              trc_action_on: "Document",
              trc_doc_type: "Payment",
              trc_doc_no: paymentData.hd_no,
              trc_aent_code: "",
              trc_ent_code: "",
              trc_action: "updated document status",
              trc_remarks: `updated payment to ${objectToAction.new_doc_status}`,
              trc_tags: [`updated payment to ${objectToAction.new_doc_status}`],
              trc_doc_docid: paymentData._id
            }
          );
        } catch (error) {
          console.log(error);
        }

        // add document in uw commission payments if its a comission payment
        if (["Approved"].includes(objectToAction.new_doc_status) && hdPayingFor?.value === "Premium") {
          for (let i = 0; i < paymentLines.length; i++) {

            // keep track of how much premium has been remiƒtted to the carrier
            try {
              await newRequest.post(
                "/uwPolicyPayment/add",
                {
                  payment_risk_note_no: paymentLines[i].ln_doc_no,
                  payment_policy_docid: paymentLines[i].ln_doc_docid,
                  payment_no: hdNo,
                  payment_mode: hdMode.value,
                  payment_date: hdGlDate,
                  payment_currency: hdCurCode.value,
                  payment_fc_amount: formatStringToNumberV2(paymentLines[i].ln_fc_amount),
                  payment_lc_amount: formatStringToNumberV2(paymentLines[i].ln_lc_amount)
                }
              );
              // console.log(`/uwPolicyPayment/add  ${JSON.stringify(res.data, null, 2)}`);
            } catch (error) {
              console.log(error)
            }

            // keep track of how much commission has been paid
            if (parseFloat(paymentLines[i].ln_comm_fc) > 0) {
              try {
                await newRequest.post(
                  "/uwPolicyCommPmt/add",
                  {
                    comm_risk_note_no: paymentLines[i].ln_doc_no,
                    comm_policy_docid: paymentLines[i].ln_doc_docid,
                    comm_doc_no: hdNo,
                    comm_mode: hdMode.value,
                    comm_date: hdGlDate,
                    comm_currency: hdCurCode.value,
                    comm_fc_amount: paymentLines[i].ln_comm_fc,
                    comm_lc_amount: paymentLines[i].ln_comm_lc,
                    comm_paid_to: "NetOffPayment",
                    comm_our_docid: paymentData._id
                  }
                );
              } catch (error) {
                console.log(error)
              }
            }
          }
        }

        if (["Approved"].includes(objectToAction.new_doc_status)) { handleConfettiClick(); }

        await fetchPayment(paymentDocId);

        setConfirmDialogAction("None");
        setNotifyDialogTitle("Success!");
        setNotifyDialogText(`Payment successfully Approved`);
        setIsProcessing(false);
      } else if (confirmDialogAction === "unmatchDocument") {
        // console.log(`Ummatch document ${objectToAction.object_id}`);
        setIsProcessing(true);
        try {
          await newRequest.post("/apPaymentLn/del", { line_docid: objectToAction.object_id });
          // await fetchPayment(paymentDocId);
          setPaymentLines((prev) => prev.filter(report => report._id !== objectToAction.object_id));
          // add to the payment amount
          setHdFcAmount((prevAmount) => parseFloat(prevAmount || 0) - (objectToAction?.amount || 0));
          setIsProcessing(false);
          showToast(`Document Unmached!`, "success");
        } catch (error) {
          setIsProcessing(false);
          console.log(error);
        }
      } else if (confirmDialogAction === "voidPayment") {
        setIsProcessing(true);
        try {
          const res = await newRequest.put(`/apPaymentHdr/upd/${paymentData._id}`, { hd_status: "Voided" });
          setIsProcessing(false);
          if (res.data.msg === "updated") {
            await fetchPayment(paymentDocId);
            showToast(t('documentVoided', { param1: hdNo }), "success");
          } else {
            setNotifyDialogTitle(t('note'));
            setNotifyDialogText(res.data?.text);
            setIsNotifyDialogOpen(true);
          }
        } catch (error) {
          setIsProcessing(false);
          console.log(error);
        }
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };


  const saveRecord = async (e) => {
    try {
      const strippedValue = hdFcAmount.replace(/,/g, "");
      if (isNaN(strippedValue)) {
        setMatchedFcAmount("");
        setNotifyDialogTitle("Error!");
        setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
        setIsNotifyDialogOpen(true);
        return;
      }


      if (!hdPayingFor) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`You must specify what the payment is paying for!`);
        setIsNotifyDialogOpen(true);
        if (payingForRef.current) {
          payingForRef.current.focus();
        }
        return;
      }

      if (!hdAcNo) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select bank account!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!hdMode) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter payment mode!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!hdGlDate) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter GL Date!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (["SHIF Corporate", "SHIF Individual"].includes(hdPayingFor?.value)) {
        if (!hdWhichPeriod?.value) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please specify period!`);
          setIsNotifyDialogOpen(true);
          return;
        }
      }

      if (hdType === "Normal") {
        if (!hdEntCode) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please select account!`);
          setIsNotifyDialogOpen(true);
          if (clientRef.current) {
            clientRef.current.focus();
          }
          return;
        }
      } else if (hdType === "Miscellaneous") {
        if (!hdMiscName) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please enter payee!`);
          setIsNotifyDialogOpen(true);
          if (miscNameRef.current) {
            miscNameRef.current.focus();
          }
          return;
        }
      }

      if (["Cheque"].includes(hdMode?.value)) {
        if (!hdChqNo) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please specify cheque number!`);
          setIsNotifyDialogOpen(true);
          return;
        }
        if (!hdChqDate) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please specify cheque date!`);
          setIsNotifyDialogOpen(true);
          return;
        }
      }

      if (paymentDocId === "new" && !hdNo) {
        await generateDocumentNo();
      }


      if (!hdFcAmount) {
        setHdFcAmount(0);
      } else {
        const lcAmount = Number(parseFloat(formatStringToNumberV2(hdFcAmount) * hdCurRate).toFixed(4));
        setHdLcAmount(lcAmount);
      }
      setIsProcessing(true);
      const paymentHeader = {
        hd_org_code: currentUser.usr_org_code,
        hd_no: hdNo || generatedDocNo,
        hd_narration: hdNarration || "",
        hd_ref_no: hdRefNo || "",
        hd_ac_no: hdAcNo?.value,
        hd_biz_unit: hdBizUnit?.value,
        hd_gl_date: hdGlDate,
        hd_cur_code: hdCurCode?.value,
        hd_cur_rate: hdCurRate,
        hd_mode: hdMode?.value,
        hd_status: hdStatus,
        hd_paying_for: hdPayingFor?.value,
        hd_aent_code: hdEntCode?.aent_code,
        hd_ent_code: hdEntCode?.value,
        hd_chq_no: hdChqNo || "",
        hd_chq_bank: hdChqBank || "",
        hd_chq_date: hdChqDate,
        hd_fc_amount: parseFloat(formatStringToNumberV2(hdFcAmount || 0, 2)) || 0,
        hd_lc_amount: Number(parseFloat(formatStringToNumberV2(hdFcAmount) * hdCurRate).toFixed(4)) || 0,
        hd_entity_name: hdEntCode?.label?.props?.children[0],
        hd_which_year: hdWhichYear?.value || currentUser?.current_fy_xx,
        hd_which_period: hdWhichPeriod?.value || "",
        hd_type: hdType,
        hd_misc_name: hdMiscName,
        hd_misc_email: hdMiscEmail,
        hd_misc_phone: hdMiscPhone,
        hd_misc_idnumber: hdMiscIdnumber,
        hd_misc_tax_pin: hdMiscTaxPin,
        hd_misc_ref_no: hdMiscRefNo,
        hd_mgl_code: hdMglCode?.value,
        hd_sgl_code: hdSglCode?.value,
        hd_mgl_sub_type: hdMglSubType
      };

      if (paymentDocId === "new") {
        try {
          const res = await newRequest.post("/apPaymentHdr/add", paymentHeader);
          logData("/apPaymentHdr/add", res.data);
          setHdNo(generatedDocNo);
          setIsProcessing(false);
          setNotifyDialogTitle(t('success'));
          setNotifyDialogText(t('successSaved', { param1: generatedDocNo }));
          setIsNotifyDialogOpen(true);
          await fetchPayment(res.data?.doc?._id);
          navigate(`/payment/${res.data?.doc?._id}`, { replace: true });
        } catch (error) {
          setIsProcessing(false);
          logData("error?.response?.data", error?.response?.data);
          const payload = error?.response?.data;
          // If backend returned your validation shape, display it
          if (payload?.result_status === "error") {
            setIsConfirmDialogOpen(false);
            setValidationMessagesResult(payload);
            setValidationMsgDialog(true);
            return;
          }
          console.log(error);
        }
      } else {

        // save changed lines
        const changedLines = paymentLines?.filter((obj) => obj.changed_xx === "Y");
        for (let i = 0; i < changedLines.length; i++) {
          const lcAmount = Number(parseFloat(formatStringToNumberV2(changedLines[i].ln_fc_amount) * hdCurRate).toFixed(4));
          await newRequest.put(
            `/apPaymentLn/upd/${changedLines[i]._id}`,
            {
              ln_fc_amount: parseFloat(formatStringToNumberV2(changedLines[i].ln_fc_amount || 0)),
              ln_lc_amount: parseFloat(formatStringToNumberV2(lcAmount || 0)),
            }
          );
        }

        // console.log(`Updating paymentDocId ${paymentDocId} and PaymentData  ${JSON.stringify(paymentData, null, 2)}`);
        await newRequest.put(`/apPaymentHdr/upd/${paymentDocId}`, paymentHeader);
        setNotifyDialogTitle(t('success'));
        setNotifyDialogText(t('successSaved', { param1: hdNo || generatedDocNo }));
        setIsNotifyDialogOpen(true);
        setIsProcessing(false);
      }
    } catch (err) {
      setIsProcessing(false);
      console.log(err);
    }
  };

  const handleAddMatchingDoc = async () => {
    try {

      if (!selectedReceipt) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select document to match!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!matchedFcAmount) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter amount to match!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      // console.log(`hdFcAmount is ${hdFcAmount} and formatted ${formatStringToNumberV2(hdFcAmount)}`)
      // console.log(`hdLcAmount is ${hdLcAmount} and formatted ${formatStringToNumberV2(hdLcAmount)}`)
      // console.log(`matchedFcAmount is ${matchedFcAmount} and formatted ${formatStringToNumberV2(matchedFcAmount)}`)
      // console.log(`matchedLcAmount is ${matchedLcAmount} and formatted ${formatStringToNumberV2(matchedLcAmount)}`)
      // console.log(`maxMatchFcAmount is ${maxMatchFcAmount} and formatted ${formatStringToNumberV2(maxMatchFcAmount)}`)
      // console.log(`maxMatchLcAmount is ${maxMatchLcAmount} and formatted ${formatStringToNumberV2(maxMatchLcAmount)}`)

      // check if entered amount is greater that document outstanding
      if (matchedFcAmount > maxMatchFcAmount) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(
          `Total outstanding to remit is <strong>${hdCurCode?.value} ${numeral(
            maxMatchFcAmount
          ).format("0,0.00")}</strong>. You CANNOT match more than this amount`
        );
        setIsNotifyDialogOpen(true);
        return;
      }
      setIsProcessing(true);
      // console.log(`selectedInstallment ${JSON.stringify(selectedInstallment, null, 2)}`);
      // insert payment line
      const res = await newRequest.post("/apPaymentLn/add", {
        ln_hd_no: hdNo,
        ln_hd_no_docid: paymentData._id,
        ln_doc_type: selectedReceipt?.ln_doc_type,
        ln_doc_no: selectedReceipt?.ln_doc_no,
        ln_doc_docid: selectedReceipt?.ln_doc_docid,
        ln_hd_status: hdStatus,
        ln_paying_for: hdPayingFor?.value,
        ln_doc_ins_no: selectedReceipt?.ln_doc_ins_no,
        ln_fc_amount: formatStringToNumberV2(matchedFcAmount),
        ln_lc_amount: formatStringToNumberV2(matchedLcAmount),
        ln_doc_amount_fc: 0,
        ln_doc_amount_lc: 0,
        ln_ent_code: hdEntCode?.value,
        ln_payment_no: selectedReceipt?.ln_hd_no,
        ln_payment_docid: selectedReceipt?.ln_hd_no_docid,
        ln_insured_ent_code: selectedReceipt?.ln_insured_ent_code,
        ln_carrier_ent_code: selectedReceipt?.ln_carrier_ent_code,
        ln_comm_fc: 0,
        ln_comm_lc: 0,
        ln_narration: "Matched"
      });

      if (res.data.msg === "exists") {
        showToast(`Document ${selectedReceipt?.label} already attached`, "error");
      } else {
        try {
          await newRequest.post("/trace/add", {
            trc_action_on: "Document",
            trc_doc_type: "Payment",
            trc_doc_no: paymentData.hd_no,
            trc_aent_code: "",
            trc_ent_code: "",
            trc_action: "matched document",
            trc_remarks: `matched ${selectedReceipt.label} totaling ${matchedFcAmount} to this payment`,
            trc_tags: [`matching`],
            trc_doc_docid: paymentData._id
          });
        } catch (error) {
          console.log(error);
        }

        // if payment already approved, add to the policy payment also
        // if (hdStatus === "Approved") {
        //   try {
        //     await newRequest.post(
        //       "/apPaymentHdr/mergeMatched",
        //       {
        //         ln_hd_no: hdNo,
        //         ln_hd_no_docid: paymentData?._id,
        //         payment_mode: hdMode?.value,
        //         payment_date: hdGlDate,
        //         payment_currency: hdCurCode?.value
        //       });
        //   } catch (error) {
        //     console.log(error);
        //   }
        // }

        setMatchedFcAmount("0");
        setMatchedLcAmount("0");
        setMaxMatchFcAmount("0");
        setMaxMatchLcAmount("0");
        setMatchedCommFc("0");
        setMatchedCommLc("0");
        setSelectedReceipt(null);
        await fetchPayment(paymentData._id);
        showToast(`Document ${selectedReceipt.pl_no} added`, "success");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsProcessing(false);
    }
  };

  const callDetailsFunction = async () => {
    try {
      await fetchBankAccounts();
      await fetchCurrencies();
      await fetchBranches();
      await fetchPaymentMode();
      await fetchPayingFor();
    } catch (err) {
      console.log(err);
    }
  };


  // top menu 
  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const [activeTab, setActiveTab] = useState(0);

  function getMenuTitle(menuKey) {
    switch (menuKey) {
      case 'details':
        return t('details');
      case 'attachments':
        return t('attachments');
      case 'matching':
        return t('matching');
      case 'correspondence':
        return t('correspondence');
      case 'comments':
        return t('comments');
      default:
        return '';
    }
  }

  const topMenus = [
    {
      menu_key: "details",
      menu_title: getMenuTitle("details"),
      menu_icon: <MdEditDocument />,
      menu_count: 0,
    },
    {
      menu_key: "attachments",
      menu_title: getMenuTitle("attachments"),
      menu_icon: <RiAttachment2 />,
      menu_count: attachmentsData.length,
    },
    {
      menu_key: "correspondence",
      menu_title: getMenuTitle("correspondence"),
      menu_icon: <MdSms />,
      menu_count: 0,
    },
    {
      menu_key: "comments",
      menu_title: getMenuTitle("comments"),
      menu_icon: <IoChatbubbles />,
      menu_count: 0,
    },
  ];

  const handleLineInputChange = (e, id, field) => {
    try {
      const newSmiData = [...paymentLines];
      const index = newSmiData.findIndex(smi => smi._id === id);
      if (index !== -1) {
        newSmiData[index][field] = e.target.value;
        newSmiData[index]["changed_xx"] = "Y";
        setPaymentLines(newSmiData);
      }
    } catch (error) {
      console.log(error);
    }
  };



  const handleLineBlur = (id, field) => {
    try {
      const updatedData = [...paymentLines];
      const index = updatedData.findIndex(smi => smi._id === id);

      if (index !== -1) {
        let value = updatedData[index][field];
        const numberFields = ["ln_fc_amount", "ln_doc_amount_fc"];
        let documentAmount = parseFloat(formatStringToNumberV2(updatedData[index]["ln_doc_amount_fc"] || 0));
        // console.log(`field is ${field}`);
        // console.log(`value is ${value}`);
        // console.log(`serviceAmount is ${serviceAmount} and formatted is ${formatStringToNumberV2(value)}`);
        // If the approved amount is greater than the service amount, reset to zero
        if (field === "ln_fc_amount" && parseFloat(formatStringToNumberV2(value)) > documentAmount) {
          updatedData[index]["ln_fc_amount"] = 0;
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(
            `You cannot match amount greater than the document amount of ${numeral(documentAmount).format("0,0.00")}!`
          );
          setIsNotifyDialogOpen(true);
        } else {
          if (numberFields.includes(field)) {
            updatedData[index][field] = formatAmountsToDecimals(value);
          } else {
            updatedData[index][field] = value;
          }
        }

        setPaymentLines(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleHdTypeChange = (next) => {
    if (next === "Miscellaneous") {
      setHdEntCode(null);
    } else if (next === "Normal") {
      setHdMiscName(null);
      setHdMiscEmail(null);
      setHdMiscPhone(null);
      setHdMiscIdnumber(null);
      setHdMglCode(null);
      setHdSglCode(null);
      setHdMiscTaxPin(null);
      setHdMiscRefNo(null);
    }
    setHdType(next);
  };

  // calculate total allocation
  useEffect(() => {
    if (!Array.isArray(paymentLines)) return;

    let fcTotal = 0;
    let lcTotal = 0;
    // console.log(`paymentLines ${JSON.stringify(paymentLines, null, 2)}`);
    for (const item of paymentLines) {
      const fc = parseFloat(formatStringToNumberV2(item?.ln_fc_amount || 0)) || 0;
      const lc = parseFloat(formatStringToNumberV2(item?.ln_lc_amount || 0)) || 0;
      fcTotal += isNaN(fc) ? 0 : fc;
      lcTotal += isNaN(lc) ? 0 : lc;
    }
    // console.log(`first fcTotal ${fcTotal} and lcTotal ${lcTotal}`);
    setAllocatedFcAmountXx(fcTotal);
    setAllocatedLcAmountXx(lcTotal);
  }, [paymentLines]);

  useEffect(() => {
    try {
      fetchReceiptsToRemit(hdEntCode?.value);
    } catch (error) {
      console.log(error);
    }
  }, [hdEntCode]);

  useEffect(() => {
    if (docid) {
      setPaymentDocId(docid);
    }
  }, [docid]);

  useEffect(() => {
    try {
      setNextAction(paymentData?.next_action_xx);
    } catch (error) {
      console.log(error);
    }
  }, [paymentData?.next_action_xx]);

  useEffect(() => {
    // fetch number generation to check if it's auto or manual
    fetchNumberGeneration();

    // if payment is selected, use paymentDocId to get details
    // if it's a new record, no fetch is necessary
    if (paymentDocId === "new" || paymentDocId === undefined) {
      setPaymentDocId("new");
      setDocumentEnabled("Y");

      // set GL date
      const currentDate = new Date();
      const formattedCurrentDate = currentDate.toISOString().split("T")[0];
      setHdGlDate(formattedCurrentDate);

      // set default business unit
      setHdBizUnit({
        value: currentUser?.biz_unit_code_xx,
        label: currentUser?.biz_unit_name_xx,
      });

      // set default currency
      setHdCurCode({
        value: currentUser?.currency_code_xx,
        label: currentUser?.currency_name_xx,
      });

      // focus client after render (same as payment but safer)
      setTimeout(() => {
        if (clientRef.current) {
          clientRef.current.focus();
        }
      }, 0);

    } else {
      fetchPayment(paymentDocId, true);
    }

    callDetailsFunction();
  }, [paymentDocId]);

  return (
    <motion.div
      className="ap-payment"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <div className="ap-payment-main-wrapper">
        <div className="ap-payment-navbar">
          <div className="ap-payment-navbar-left">
            <span className="page-title"> {hdEntCode?.label || t('newPayment')}</span>
            <span className="sub-title xrsmall" style={{ fontSize: "10px" }}>{`${hdMode?.label} [${hdStatus}]`}</span>
          </div>
          <div className="ap-payment-navbar-right">

            {paymentDocId !== "new" && (
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#0f766e5d"
                endIcon={<RefreshIcon />}
                onClick={async () => { await fetchPayment(paymentDocId) }}
              >
                {t('refresh')}
              </CustomLoadingButton>
            )}
            {paymentDocId !== "new" && nextAction !== "None" && (
              <>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#fbbf24"
                  endIcon={<DragIndicatorIcon />}
                  onClick={() => {
                    try {
                      // console.log(`Status is ${hdStatus}`);
                      let action_text = "";
                      let new_doc_status = hdStatus;
                      switch (hdStatus) {
                        case "New":
                          action_text = `Do you want to Validate this payment ?`;
                          setInvokedAction("Validate");
                          new_doc_status = "Validated";
                          break;
                        case "Validated":
                          action_text = `Do you want to Approve this payment?`;
                          setInvokedAction("Approve");
                          new_doc_status = "Approved";
                          break;
                        case "Approved":
                          action_text = `Do you want to cancel this payment?`;
                          setInvokedAction("Cancel");
                          new_doc_status = "Cancelled";
                          break;
                        default:
                          action_text = "";
                          new_doc_status = "";
                      }
                      // check payment mode
                      if (new_doc_status === "Validated") {
                        if (formatStringToNumberV2(hdFcAmount) === 0) {
                          setIsConfirmDialogOpen(false);
                          setConfirmDialogAction("None");
                          setNotifyDialogTitle("Note!");
                          setNotifyDialogText(
                            `Please enter payment amount.`
                          );
                          setIsNotifyDialogOpen(true);
                          return;
                        } else {
                          const lcAmount = Number(parseFloat(formatStringToNumberV2(hdFcAmount) * hdCurRate).toFixed(4));
                          setHdLcAmount(lcAmount);
                        }

                        if (hdMode?.value === "Select") {
                          setNotifyDialogTitle("Note!");
                          setNotifyDialogText(`Please select payment mode!`);
                          setIsNotifyDialogOpen(true);
                          return;
                        }
                      }


                      setObjectToAction({
                        object_id: paymentData._id,
                        action_text: action_text,
                        new_doc_status,
                      });
                      setConfirmDialogAction("paymentAction");
                      setIsConfirmDialogOpen(true);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  {nextAction}
                </CustomLoadingButton>
              </>
            )}
            {documentEnabled === "Y" && (
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#00D37F"
                tooltip="Save changes"
                endIcon={<FaSave />} onClick={saveRecord}>
                {t('save')}
              </CustomLoadingButton>
            )}
            {paymentDocId !== "new" && (
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                endIcon={<IoDocumentTextSharp />}
                variant="tint"
                color="#2563EB"
                tooltip="Run reports for this document"
                onClick={() => setReportsDialogOpen(true)}>
                {t('reports')}
              </CustomLoadingButton>
            )}
            <CustomLoadingButton
              currentTheme={currentTheme}
              iconPosition="end"
              borderRadiusType="both"
              endIcon={<MdClose />}
              variant="tint"
              color="#f55656"
              tooltip="Close this document"
              onClick={() => navigate(-1)}>
              {t('close')}
            </CustomLoadingButton>
            {paymentDocId !== "new" && (
              <div className="collaborator-icon"
                onClick={openCollab}>
                <MdForum className="icon" />
              </div>
            )}
          </div>
        </div>
        {isLoading ? (
          <div className="no-content">
            <ScaleLoader
              color="var(--primary)"
              height={50}
              radius={8}
              width={4}
            />
          </div>
        ) : (
          <div className="content-summary-wrapper">
            <div className="content-wrapper">
              <div className="tabs-container">
                <div className="tab-header">
                  {topMenus?.map((tab, index) => (
                    <div
                      key={index}
                      className={`${activeTab === index ? 'tab active' : 'tab'}`}
                      onClick={() => handleTabClick(index)}
                    >
                      <span className={`${activeTab === index ? 'tab-icon active' : 'tab-icon'}`}>
                        {tab.menu_icon}
                      </span>
                      <span className={`${activeTab === index ? 'tab-title active' : 'tab-title'}`}>{tab.menu_title}</span>
                      {tab.menu_count > 0 && <Badge badgeContent={tab.menu_count} showZero sx={{ '& .MuiBadge-badge': { backgroundColor: activeTab === index ? '#9c27b0' : '#c3c3c3', color: 'white' } }}
                        className="tab-badge" />}
                    </div>
                  ))}
                </div>
              </div>
              <div className="payment-content-details">
                {/* Summary Information */}
                {activeTab === 0 &&
                  <>
                    {documentEnabled === "N" &&
                      <div className="content-details-row approved-doc">
                        <span>{`${t('payment').toUpperCase()}: ${hdNo}`}</span>
                        <span>{`${t('bizUnit').toUpperCase()}: ${hdBizUnit?.label}`}</span>
                        <span className={`main-title status ${getCssValue(hdStatus)}`}>{hdStatus}</span>
                      </div>}
                    {/* received from */}
                    <ExpandableComponent
                      title={t('payee').toUpperCase()}
                      subtitle={
                        <CustomRadioGroup
                          id="hd_type"
                          value={hdType}
                          onChange={handleHdTypeChange}
                          label={hdType}
                          labelPosition="end"
                          labelWidth="max-content"
                          disabled={documentEnabled !== "Y"}
                          options={["Normal", "Miscellaneous"].map((v) => ({ value: v, label: v }))}
                        />
                      }
                      defaultExpanded={true}
                    >
                      <div className="content-details-row client">
                        {hdType === "Normal" ?
                          <motion.div
                            className="entity-details-container"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1, transition: { duration: 1 } }}
                            exit={{ opacity: 0, transition: { duration: 1 } }}>
                            <div className="entity-details-wrapper">
                              <div className="entity-details-left">
                                {hdEntCode?.ent_photo_url ?
                                  <img src={hdEntCode?.ent_photo_url} alt="" className="img" />
                                  :
                                  <InitialsAvatar
                                    name={hdEntCode?.ent_name}
                                    size={60}
                                    currentTheme={currentTheme}
                                  />}
                              </div>
                              <div className="entity-details-right">
                                <div className="name-row">
                                  <div className="input-item-with-label">
                                    <AsyncSelect
                                      ref={clientRef}
                                      id="hd_ent_code"
                                      name="hd_ent_code"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                          ...base,
                                          zIndex: 9999,
                                        })
                                      }}
                                      width="450px"
                                      value={hdEntCode}
                                      onChange={(selectedOption) => setHdEntCode(selectedOption)}
                                      loadOptions={fetchClientsBySearch}
                                      isSearchable={true}
                                      isDisabled={documentEnabled === "N"}
                                      placeholder={t('payee').toUpperCase()}
                                      noOptionsMessage={() => customNoOptionsMessage("Type Minimum 3 Letter to Search")}
                                    />
                                  </div>
                                  <span className="sub-title">
                                    {paymentData?.client_details_xx?.ent_type === "Individual" &&
                                      paymentData?.client_details_xx?.ent_occupation_xx &&
                                      <span className="sub-title">{`${t('occupation')} : ${paymentData?.client_details_xx?.ent_occupation_xx}`}</span>
                                    }
                                    {paymentData?.client_details_xx?.ent_type !== "Individual" &&
                                      paymentData?.client_details_xx?.ent_sub_sector_xx &&
                                      <span className="sub-title">{`${t('sector')} : ${paymentData?.client_details_xx?.ent_sector_xx} | ${paymentData?.client_details_xx?.ent_sub_sector_xx}`}</span>
                                    }
                                  </span>
                                </div>
                                <div className="email-phone-row">
                                  <span className="email-phone-details" style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      try {
                                        setEmailData({
                                          to: hdEntCode?.ent_email,
                                          cc: '',
                                          bcc: '',
                                          subject: `PAYMENT NO ${hdNo}`,
                                          show_attach: "Y",
                                          attached_urls: [],
                                          binary_docs: [],
                                          doc_no: hdNo,
                                          doc_type: "Payment",
                                          doc_id: paymentDocId,
                                          entity_codes: [hdEntCode?.value],
                                          search_string: hdEntCode?.label?.props?.children[0] + "," + hdNo,
                                          carrierName: '',
                                          productName: '',
                                          clientName: hdEntCode?.label?.props?.children[0],
                                          riskNoteNo: hdNo,
                                          daysToRenewal: paymentData?.expiring_in_days,
                                          expiryDate: paymentData?.fmt_to_date,
                                          insuredName: hdEntCode?.label?.props?.children[0],
                                          outstandingPremium: paymentData?.outstandingPremium,
                                          policyCurrency: hdCurCode?.value,
                                          policyNumber: hdNo,
                                          policyPremium: paymentData?.fmt_policy_fc_prem,
                                          policyPremiumTotal: paymentData?.fmt_total_fc_prem,
                                          policySumInsured: paymentData?.fmt_total_fc_si,
                                          policyFromDate: paymentData?.fmt_fm_date,
                                          policyToDate: paymentData?.fmt_to_date,
                                          tpt_category: []
                                        });
                                        setEmailDialogOpen(true);
                                      } catch (error) {
                                        console.log(error)
                                      }
                                    }}>
                                    <MdAlternateEmail className="icon" /> <h1 className="sub-title">{hdEntCode?.ent_email || "Unspecified"}</h1>
                                  </span>
                                  <span className="email-phone-details">
                                    <MdPhone className="icon" /> <h1 className="sub-title">{hdEntCode?.ent_phone_no || "Unspecified"}</h1>
                                  </span>
                                  <span className="email-phone-details">
                                    <TbCertificate className="icon" /> <h1 className="sub-title">{hdEntCode?.aent_name_xx || ""}</h1>
                                  </span>
                                  <span className="email-phone-details"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate(`/entity/${paymentData?.client_details_xx?._id}`)}>
                                    <TagIcon className="icon" /> <h1 className="sub-title">{hdEntCode?.ent_code}</h1>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </motion.div>
                          :
                          <motion.div
                            className="misc-container"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1, transition: { duration: 1 } }}
                            exit={{ opacity: 0, transition: { duration: 1 } }}>
                            <div className="misc-row">
                              <div className="misc-row-avatar">
                                <InitialsAvatar
                                  name={hdMiscName}
                                  size={60}
                                  currentTheme={currentTheme}
                                />
                              </div>
                              <div className="misc-row-left">
                                <div className="input-item-with-label">
                                  <input
                                    ref={miscNameRef}
                                    id="hd_misc_name"
                                    name="hd_misc_name"
                                    type="text"
                                    placeholder={t('fullName').toUpperCase()}
                                    value={hdMiscName}
                                    className="form-input-item"
                                    style={{ width: "450px" }}
                                    onChange={(e) => setHdMiscName(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                                <div className="input-item-with-label">
                                  <input
                                    id="hd_misc_email"
                                    name="hd_misc_email"
                                    type="email"
                                    placeholder={t('email').toUpperCase()}
                                    value={hdMiscEmail}
                                    className="form-input-item"
                                    style={{ width: "450px" }}
                                    onChange={(e) => setHdMiscEmail(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                              </div>
                              <div className="misc-row-right">
                                <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                                  <label htmlFor="hd_misc_phone" className="form-dropdown-label">{t('phoneNo').toUpperCase()}</label>
                                  <input
                                    id="hd_misc_phone"
                                    name="hd_misc_phone"
                                    type="text"
                                    placeholder={t('phoneNo').toUpperCase()}
                                    value={hdMiscPhone}
                                    className="form-input-item"
                                    style={{ width: "200px" }}
                                    onChange={(e) => setHdMiscPhone(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                                <div className="input-item-with-label">
                                  <label htmlFor="hd_misc_idnumber" className="form-dropdown-label">{t('idNumber').toUpperCase()}</label>
                                  <input
                                    id="hd_misc_idnumber"
                                    name="hd_misc_idnumber"
                                    type="text"
                                    placeholder={t('idNumber').toUpperCase()}
                                    value={hdMiscIdnumber}
                                    className="form-input-item"
                                    style={{ width: "200px" }}
                                    onChange={(e) => setHdMiscIdnumber(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="misc-row">
                              <div className="misc-row-left">
                                <div className="input-item-with-label">
                                  <label htmlFor="hd_sgl_code" className="form-dropdown-label" style={{ width: "100px" }}>{t('main').toUpperCase()}</label>
                                  <AsyncSelect
                                    id="hd_mgl_code"
                                    name="hd_mgl_code"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="450px"
                                    value={hdMglCode}
                                    onChange={(selectedOption) => {
                                      try {
                                        setHdMglCode(selectedOption);
                                        setHdMglSubType(selectedOption?.ma_sub_type);
                                        setHdSglCode(null);
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    loadOptions={(inputValue, callback) => fetchMainLedgers(inputValue, callback, [])}
                                    isSearchable
                                    isClearable
                                    isDisabled={documentEnabled === "N"}
                                    placeholder={t('main')}
                                    noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
                                </div>
                                {<div className="input-item-with-label">
                                  <label htmlFor="hd_sgl_code" className="form-dropdown-label" style={{ width: "100px" }}>{t('sub').toUpperCase()}</label>
                                  {hdMglSubType === "Account" ?
                                    <AsyncSelect
                                      id="hd_sgl_code"
                                      name="hd_sgl_code"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                          ...base,
                                          zIndex: 9999,
                                        })
                                      }}
                                      width="450px"
                                      value={hdSglCode}
                                      onChange={(selectedOption) => setHdSglCode(selectedOption)}
                                      loadOptions={(inputValue, callback) => fetchSubLedgers(inputValue, callback, hdMglCode?.value)}
                                      isSearchable
                                      isClearable
                                      isDisabled={documentEnabled === "N"}
                                      placeholder={t('sub')}
                                      noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
                                    :
                                    <AsyncSelect
                                      id="misc_ent_code"
                                      name="misc_ent_code"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                          ...base,
                                          zIndex: 9999,
                                        })
                                      }}
                                      width="450px"
                                      value={hdSglCode}
                                      onChange={(selectedOption) => setHdSglCode(selectedOption)}
                                      loadOptions={fetchClientsBySearch}
                                      isSearchable
                                      isClearable
                                      isDisabled={documentEnabled === "N"}
                                      placeholder={t('entity').toUpperCase()}
                                      noOptionsMessage={() =>
                                        customNoOptionsMessage(
                                          "Type Minimum 3 Letter to Search"
                                        )
                                      }
                                    />}

                                </div>}
                              </div>
                              <div className="misc-row-right">
                                <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                                  <label htmlFor="hd_misc_tax_pin" className="form-dropdown-label">{t('taxPin').toUpperCase()}</label>
                                  <input
                                    id="hd_misc_tax_pin"
                                    name="hd_misc_tax_pin"
                                    type="text"
                                    placeholder={t('taxPin').toUpperCase()}
                                    value={hdMiscTaxPin}
                                    className="form-input-item"
                                    style={{ width: "200px" }}
                                    onChange={(e) => setHdMiscTaxPin(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                                <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                                  <label htmlFor="hd_misc_ref_no" className="form-dropdown-label">{t('refNo').toUpperCase()}</label>
                                  <input
                                    id="hd_misc_ref_no"
                                    name="hd_misc_ref_no"
                                    type="text"
                                    placeholder={t('refNo').toUpperCase()}
                                    value={hdMiscRefNo}
                                    className="form-input-item"
                                    style={{ width: "200px" }}
                                    onChange={(e) => setHdMiscRefNo(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                              </div>
                            </div>
                          </motion.div>}
                      </div>
                    </ExpandableComponent>
                    {/* end of received from  */}

                    {/* payment details */}
                    <ExpandableComponent
                      title={t('details').toUpperCase()}
                      subtitle={<span className={`status ${hdStatus}`}>{`${t('status').toUpperCase()} ${hdStatus}`}</span>}
                      defaultExpanded={true}
                    >
                      <div className="content-details-row">
                        <div className="content-details-left">
                          <div className="input-item-with-label">
                            <label htmlFor="hd_ac_no"
                              className="form-dropdown-label"
                              style={{ width: "100px" }}>
                              {t('source').toUpperCase()}
                            </label>
                            <Select
                              id="hd_ac_no"
                              name="hd_ac_no"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="450px"
                              value={hdAcNo}
                              onChange={(selectedOption) => setHdAcNo(selectedOption)}
                              options={bankAccounts}
                              isSearchable={true}
                              isDisabled={documentEnabled === "N"}
                              placeholder={t('source').toUpperCase()}
                            />
                          </div>
                          <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "start",
                            justifyContent: "space-between",
                            width: "100%",
                          }}>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="hd_biz_unit"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('bizUnit').toUpperCase()}
                              </label>
                              <Select
                                id="hd_biz_unit"
                                name="hd_biz_unit"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="170px"
                                value={hdBizUnit}
                                onChange={(selectedOption) => {
                                  try {
                                    setHdBizUnit(selectedOption);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                options={branches}
                                isSearchable={true}
                                isDisabled={documentEnabled === "N"}
                                placeholder={t('bizUnit').toUpperCase()}
                              />
                            </div>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="hd_ref_no"
                                className="form-dropdown-label"
                              >
                                {t('refNo').toUpperCase()}
                              </label>
                              <input
                                id="hd_ref_no"
                                name="hd_ref_no"
                                type="text"
                                placeholder={t('refNo').toUpperCase()}
                                value={hdRefNo}
                                className="form-input-item"
                                style={{ width: "170px" }}
                                onChange={(e) => setHdRefNo(e.target.value)}
                                disabled={documentEnabled === "N"}
                              />
                            </div>
                          </div>
                          <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "start",
                            justifyContent: "space-between",
                            width: "100%",
                          }}>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="hd_mode"
                                className="form-dropdown-label" style={{ width: "100px" }}
                              >
                                {t('mode').toUpperCase()}
                              </label>
                              <Select
                                id="hd_mode"
                                name="hd_mode"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="170px"
                                value={hdMode}
                                onChange={(selectedOption) => setHdMode(selectedOption)}
                                options={paymentMode}
                                isSearchable={true}
                                placeholder={t('mode').toUpperCase()}
                                isDisabled={documentEnabled === "N"}
                              />
                            </div>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="hd_chq_no"
                                className="form-dropdown-label"
                              >
                                {t('chqNo').toUpperCase()}
                              </label>
                              <input
                                id="hd_chq_no"
                                name="hd_chq_no"
                                type="text"
                                placeholder="CHQ NO"
                                disabled={documentEnabled === "N"}
                                value={hdChqNo}
                                className="form-input-item"
                                style={{ width: "170px" }}
                                onChange={(e) => setHdChqNo(e.target.value)}
                              />
                            </div>
                          </div>
                          <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "start",
                            justifyContent: "space-between",
                            width: "100%",
                          }}>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="hd_paying_for"
                                className="form-dropdown-label" style={{ width: "100px" }}
                              >
                                {t('purpose').toUpperCase()}
                              </label>
                              <Select
                                id="hd_paying_for"
                                name="hd_paying_for"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="170px"
                                value={hdPayingFor}
                                onChange={(selectedOption) => setHdPayingFor(selectedOption)}
                                options={payingFor}
                                isSearchable={true}
                                placeholder={t('purpose').toUpperCase()}
                                isDisabled={documentEnabled === "N"}
                              />
                            </div>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="hd_chq_date"
                                className="form-dropdown-label"
                              >
                                {t('chqDate').toUpperCase()}
                              </label>
                              <input
                                id="hd_chq_date"
                                name="hd_chq_date"
                                type="date"
                                placeholder="CHQ DATE"
                                value={hdChqDate}
                                className="form-input-item"
                                style={{ width: "170px" }}
                                onChange={(e) => {
                                  try {
                                    const formattedChqDate = moment(
                                      e.target.value
                                    ).format("YYYY-MM-DD");
                                    setHdChqDate(formattedChqDate);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                disabled={documentEnabled === "N"}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="content-details-right">
                          <div className="input-item-with-label">
                            <label htmlFor="hd_no" className="form-dropdown-label">
                              {t('paymentNo').toUpperCase()}
                            </label>
                            <input
                              id="hd_no"
                              name="hd_no"
                              type="text"
                              placeholder={t('paymentNo').toUpperCase()}
                              value={hdNo}
                              disabled={!isDocumentNumberSetup}
                              className="form-input-item"
                              style={{ width: "200px" }}
                              onChange={(e) => setHdNo(e.target.value)}
                            />
                          </div>
                          <div className="input-item-with-label">
                            <label
                              htmlFor="hd_gl_date"
                              className="form-dropdown-label"
                            >
                              {t('glDate').toUpperCase()}
                            </label>
                            <input
                              id="hd_gl_date"
                              name="hd_gl_date"
                              type="date"
                              placeholder={t('glDate').toUpperCase()}
                              value={hdGlDate}
                              className="form-input-item"
                              style={{ width: "200px" }}
                              onChange={handleGlDateChange}
                              disabled={documentEnabled === "N"}
                            />
                          </div>
                          <div className="input-item-with-label">
                            <label
                              htmlFor="hd_cur_code"
                              className="form-dropdown-label"
                              style={{ width: "80px" }}
                            >
                              {t('currency').toUpperCase()}
                            </label>
                            <Select
                              id="hd_cur_code"
                              name="hd_cur_code"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="200px"
                              value={hdCurCode}
                              onChange={async (selectedOption) => {
                                try {
                                  //get currency rate
                                  if (
                                    selectedOption.value !==
                                    currentUser.currency_code_xx
                                  ) {
                                    setHdCurCode(selectedOption);

                                    // get rate
                                    const res = await newRequest.post(
                                      "/glCurrencyRate/find", {
                                      rate_cur_code_fm: selectedOption.value,
                                      rate_cur_code_to: currentUser.currency_code_xx,
                                      rate_date: hdGlDate,
                                    });

                                    if (!res.data || !res.data?.rate) {
                                      setHdCurCode({
                                        value: currentUser.currency_code_xx,
                                        label: currentUser.currency_name_xx,
                                      });
                                      setHdCurRate(1);
                                      setNotifyDialogTitle("Note!");
                                      setNotifyDialogText(
                                        `Conversion Rate from <strong>${selectedOption.value
                                        } to ${currentUser.currency_code_xx
                                        } for date ${moment(hdGlDate).format(
                                          "DD-MMM-YYYY"
                                        )}</strong> NOT found. Currency will reset to <strong>${currentUser.currency_code_xx
                                        }</strong>`
                                      );
                                      setIsNotifyDialogOpen(true);
                                    } else {
                                      setHdCurRate(res.data.rate);
                                    }
                                  } else {
                                    setHdCurCode({
                                      value: currentUser.currency_code_xx,
                                      label: currentUser.currency_code_xx,
                                    });
                                    setHdCurRate(1);
                                    const lcAmount = Number(parseFloat(formatStringToNumberV2(hdFcAmount)).toFixed(4));
                                    setHdLcAmount(lcAmount);
                                  }
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              options={currencies}
                              isSearchable={true}
                              isDisabled={documentEnabled === "N"}
                              placeholder={t('currency').toUpperCase()}
                            />
                          </div>
                          <div className="input-item-with-label">
                            <label
                              htmlFor="hd_fc_amount"
                              className="form-dropdown-label"
                            >
                              {t('amount').toUpperCase()}
                            </label>
                            <input
                              id="hd_fc_amount"
                              name="hd_fc_amount"
                              type="text"
                              placeholder="0.00"
                              value={hdFcAmount}
                              className="form-input-item"
                              style={{ width: "200px", textAlign: "right" }}
                              onChange={(e) => setHdFcAmount(e.target.value)}
                              disabled={documentEnabled === "N"}
                              onBlur={handleFcAmountBlur}
                            />
                          </div>

                        </div>
                      </div>
                      <div className="content-details-row" style={{ marginTop: "15px" }}>
                        <div className="input-item-with-label"
                          style={{
                            display: "flex",
                            width: "100%",
                          }}>
                          <label
                            htmlFor="hd_narration"
                            className="form-dropdown-label"
                            style={{ width: "115px", alignSelf: "flex-start" }}
                          >
                            {t('narration').toUpperCase()}
                          </label>
                          <textarea
                            id="hd_narration"
                            name="hd_narration"
                            type="text"
                            placeholder={t('narration').toUpperCase()}
                            value={hdNarration}
                            row={5}
                            className="form-input-item"
                            style={{ width: "100%" }}
                            onChange={(e) => setHdNarration(e.target.value)}
                            disabled={documentEnabled === "N"}
                          />
                        </div>
                      </div>
                    </ExpandableComponent>
                    {/* end if payment details */}
                    {/* payment lines */}
                    <ExpandableComponent
                      title={t('matchedRecords').toUpperCase()}
                      subtitle={
                        ["regulator"].includes(currentUser?.token_org_type) &&
                        documentEnabled === "Y" &&
                        paymentDocId !== "new" &&
                        <CustomLoadingButton
                          currentTheme={currentTheme}
                          iconPosition="end"
                          height={"36px"}
                          borderRadiusType="right"
                          endIcon={<MdAdd />}
                          onClick={async () => {
                            try {
                              await fetchClaims();
                              setIsSearchDialogOpened(true);
                            } catch (error) {
                              console.log(error);
                            }
                          }}>
                          {t('addClaims')}
                        </CustomLoadingButton>
                      }
                      defaultExpanded={true}
                    >
                      <div className="lines-wrapper">
                        {paymentDocId === "new" && (
                          <motion.div className="doc-not-saved"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1, transition: { duration: 1 } }}
                            exit={{ opacity: 0, transition: { duration: 1 } }}>
                            NEW PAYMENT. AFTER SAVING, YOU'LL BE ABLE TO PERFORM MORE ACTIONS
                          </motion.div>
                        )}
                        {paymentDocId !== "new" &&
                          !["Cancelled", "Voided"].includes(hdStatus) &&
                          (
                            <>
                              {["broker", "agent", "insurance"].includes(currentUser?.token_org_type) &&
                                !["Cancelled"].includes(hdStatus) &&
                                (formatStringToNumberV2(hdFcAmount) - allocatedFcAmountXx) > 0 &&
                                <div className="inline-buttons-wrapper">
                                  <label
                                    htmlFor="rn"
                                    className="form-dropdown-label"
                                    style={{ width: "max-content" }}
                                  >
                                    {t('doc').toUpperCase()}
                                  </label>
                                  {/* policy */}
                                  <Select
                                    id="rn"
                                    name="rn"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="350px"
                                    dropdownHeight={4 * 42}
                                    value={selectedReceipt}
                                    onChange={async (selectedOption) => {
                                      try {
                                        // console.log(`selectedOption  ${JSON.stringify(selectedOption, null, 2)}`);
                                        setSelectedReceipt(selectedOption);
                                        setMatchedFcAmount(formatAmountsToDecimals(selectedOption?.os_to_remit_amount_fc, 2));
                                        setMatchedLcAmount(formatAmountsToDecimals(selectedOption?.os_to_remit_amount_lc, 2));
                                        // maximum amount that can be matched
                                        setMaxMatchFcAmount(selectedOption?.os_to_remit_amount_fc);
                                        setMaxMatchLcAmount(selectedOption?.os_to_remit_amount_lc);
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    options={paymentsToRemit}
                                    isSearchable={true}
                                    placeholder={t('doc').toUpperCase()}
                                  />
                                  <div className="input-item-with-label">
                                    <label
                                      htmlFor="matched_fc_amount"
                                      className="form-dropdown-label"
                                      style={{ width: "80px" }}
                                    >
                                      {t('amount').toUpperCase()}
                                    </label>
                                    <input
                                      id="matched_fc_amount"
                                      name="matched_fc_amount"
                                      type="text"
                                      placeholder="0.00"
                                      value={matchedFcAmount}
                                      className="form-input-item"
                                      style={{ width: "170px", textAlign: "right" }}
                                      onChange={(e) => setMatchedFcAmount(e.target.value)}
                                      onBlur={handleMatchedFcAmountBlur}
                                    />
                                  </div>
                                  <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#0ea5a4"
                                    tooltip={selectedReceipt?.ln_doc_no ? `Match ${selectedReceipt?.ln_doc_no || ""} to this receipt` : `Select document to add`}
                                    endIcon={<AddIcon />}
                                    onClick={handleAddMatchingDoc}
                                  >
                                    {t('add')}
                                  </CustomLoadingButton>
                                </div>}
                              {slicedPaymentLines.length > 0 &&
                                <motion.div
                                  className="table-content"
                                  initial={{ opacity: 0 }}
                                  animate={{ opacity: 1, transition: { duration: 1 } }}
                                  exit={{ opacity: 0, transition: { duration: 1 } }}>
                                  <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                    <Table sx={{ width: "max-content", border: 'none' }}>
                                      <TableHead className="tablehead">
                                        <TableRow className="tablerow">
                                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                            #
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                            <span> {t('type').toUpperCase()}</span>
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                                            <span> {t('document').toUpperCase()}</span>
                                          </TableCell>
                                          <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                            <span> {t('allocated').toUpperCase()}</span>
                                          </TableCell>
                                          {documentEnabled === "Y" &&
                                            <TableCell className="table-cell center" style={{ maxWidth: "100px", }}>
                                              <span> {t('action').toUpperCase()}</span>
                                            </TableCell>}
                                        </TableRow>
                                      </TableHead>
                                      <TableBody className="tablebody">
                                        {slicedPaymentLines?.map((row, index) => (
                                          <TableRow
                                            key={row._id}
                                            className={`${selectedPaymentLine?._id === row._id ? "tablerow current" : "tablerow"}`}
                                            onClick={() => setSelectedPaymentLine(row)}
                                          >
                                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                              <span>{currentPage * rowsPerPage + index + 1}</span>
                                            </TableCell>
                                            <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                              <span>{row?.ln_doc_type}</span>
                                            </TableCell>
                                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                                              <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                                  <span className="sub-title">{row?.ln_doc_no}</span>
                                                  <span className="sub-title xrsmall" style={{ fontSize: "10px" }}>{row?.sub_narration_xx}</span>
                                                </div>
                                                <span className="sub-title ">{row.main_narration_xx}</span>
                                                {row?.ln_payment_no && <span className="sub-title xrsmall" style={{ fontSize: "10px" }}>{`${t('payment')} : ${row?.ln_payment_no}`}</span>}
                                              </div>
                                            </TableCell>
                                            <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                              {documentEnabled === "Y" ?
                                                <div className="input-item-with-label">
                                                  <input
                                                    id={`${row._id}_ln_fc_amount`}
                                                    name={`${row._id}_ln_fc_amount`}
                                                    value={row?.ln_fc_amount}
                                                    onChange={(e) => handleLineInputChange(e, row._id, 'ln_fc_amount')}
                                                    onBlur={() => handleLineBlur(row._id, "ln_fc_amount")}
                                                    style={{ width: "100%", textAlign: "right" }}
                                                    className="form-input-item table"
                                                  />
                                                </div>
                                                : <h1 className='normal-title'>{numeral(row?.ln_fc_amount).format("0,0.00")}</h1>}
                                            </TableCell>
                                            {documentEnabled === "Y" &&
                                              <TableCell className="table-cell center" style={{ maxWidth: "100px", }}>
                                                <CircularButton
                                                  currentTheme={currentTheme}
                                                  onClick={() => {
                                                    try {
                                                      setObjectToAction({
                                                        object_id: row._id,
                                                        action_text: `Unmatch ${row?.ln_doc_no} from this payment?`,
                                                        new_doc_status: "unmatch",
                                                        amount: row?.ln_fc_amount
                                                      });
                                                      setConfirmDialogAction("unmatchDocument");
                                                      setIsConfirmDialogOpen(true);
                                                    } catch (error) {
                                                      console.log(error);
                                                    }
                                                  }} color="#E53935" icon={<MdDelete />} width={"30px"} height={"30px"} />
                                              </TableCell>}
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                    {paymentLines?.length >
                                      rowsPerPage
                                      && <TablePagination
                                        rowsPerPageOptions={[5]}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleRowsPerPage}
                                        component="div"
                                        count={paymentLines?.length}
                                        rows={paymentLines}
                                        page={currentPage}
                                        onPageChange={handlePageChange}
                                      />}
                                  </TableContainer>
                                </motion.div>}
                            </>
                          )}
                      </div>
                    </ExpandableComponent>
                    {/* end of payment lines */}
                    {/* T-Account after posting document */}
                    {["Approved", "Cancelled"].includes(hdStatus) &&
                      <Taccount key={hdStatus} originalDocId={paymentDocId} originalDocno={hdNo} originalDocType={"AP Payment"} endorsementIndex={0} />}
                  </>
                }
                {activeTab === 1 && <>
                  <motion.div
                    className="tabs-view-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="attachment">
                      <FileUploadComponent
                        documentNo={hdNo}
                        documentId={paymentDocId}
                        documentType="AP Payment"
                        fetchDocumentAttachments={fetchDocumentAttachments}
                        uploadFolder={`ap-payment/${paymentDocId}`} />
                      <div className="attachment-files">
                        <AllFiles filesList={attachmentsData} />
                      </div>
                    </div>
                  </motion.div>
                </>}
                {activeTab === 2 &&
                  <motion.div
                    className="correspondence"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                  >
                    <Correspondence
                      correspondenceParams={{ fetch_type: "document", doc_id: paymentDocId, doc_no: hdNo, doc_type: "Payment", entity_codes: [hdEntCode?.value] }}
                      passedEmailData={{
                        to: `${paymentData?.client_email_xx}`,
                        cc: `${currentUser?.usr_email}`,
                        bcc: '',
                        subject: `Payment No ${hdNo}`,
                        show_attach: "Y",
                        attached_urls: [],
                        binary_docs: [],
                        doc_no: hdNo,
                        doc_type: "Payment",
                        doc_id: paymentDocId,
                        entity_codes: [hdEntCode?.value],
                        search_string: hdEntCode?.label?.props?.children[0] + "," + hdNo,
                        carrierName: "",
                        productName: "",
                        clientName: hdEntCode?.label?.props?.children[0],
                        riskNoteNo: hdNo,
                        daysToRenewal: 0,
                        expiryDate: "",
                        insuredName: hdEntCode?.label?.props?.children[0],
                        outstandingPremium: 0,
                        policyCurrency: hdCurCode?.value,
                        policyNumber: hdNo,
                        policyPremium: "",
                        policyPremiumTotal: "",
                        policySumInsured: "",
                        policyFromDate: "",
                        policyToDate: "",
                        tpt_category: []
                      }} />
                  </motion.div>
                }
                {activeTab === 3 &&
                  <AllDocsNote
                    docId={paymentData._id}
                    docType="Payment"
                    noteType={"Normal"}
                  />
                }
              </div>
            </div>
            <div className="payment-summary-wrapper">
              {paymentDocId !== "new" &&
                hdStatus === "New" &&
                <div className="panel-card void"
                  onClick={() => {
                    try {
                      setObjectToAction({
                        object_id: paymentData._id,
                        action_text: `Do you want to Void ${hdNo}?<br/><br/>${t('thisActionIsIrrevasible')}`
                      });
                      setConfirmDialogAction("voidPayment");
                      setIsConfirmDialogOpen(true);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  <div className="panel-card__header">
                    <div className="panel-card__titleRow">
                      <h1 className="panel-card__title">{t("voidPayment").toUpperCase()}</h1>
                    </div>
                    <div className="panel-card__body">
                      <div className="kv-row">
                        <span className="kv-key">{t("voidPaymentDesc").toUpperCase()}</span>
                      </div>
                    </div>
                  </div>
                </div>}
              <div className="panel-card" style={{ padding: "10px" }}>
                <WorkedOnBy name={paymentData?.updated_by_name_xx} photoUrl={paymentData?.updated_by_photo_url_xx} time_ago_xx={paymentData?.time_ago_xx} />
              </div>
              <div className="summary-content">
                {hdCurCode?.value !== currentUser?.currency_code_xx && (
                  <div
                    className="input-item-with-label"
                    style={{ alignSelf: "flex-end", margin: "0px 5px 5px 0px" }}
                  >
                    <label
                      htmlFor="hd_cur_rate"
                      className="form-dropdown-label"
                    >
                      {t('rate').toUpperCase()}
                    </label>
                    <input
                      id="hd_cur_rate"
                      name="hd_cur_rate"
                      type="number"
                      placeholder="0.00"
                      value={hdCurRate}
                      className="form-input-item"
                      style={{
                        width: "100px",
                        margin: "5px 0px",
                        textAlign: "right",
                      }}
                      onChange={(e) => setHdCurRate(e.target.value)}
                      disabled={documentEnabled === "N"}
                    />
                  </div>
                )}
                <motion.div
                  className="summary-view"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                  {/* ===================== SUMMARY CARD ===================== */}
                  <div className="panel-card">
                    <div className="panel-card__header">
                      <div className="panel-card__titleRow">
                        <h1 className="panel-card__title">{t("summary").toUpperCase()}</h1>

                        {currentUser?.currency_code_xx !== hdCurCode?.value && (
                          <CustomButtonSmall
                            style={{ display: "flex" }}
                            onClick={() => setFiguresToShow((p) => (p === "org" ? "base" : "org"))}
                          >
                            {figuresToShow === "org"
                              ? `view ${currentUser?.currency_code_xx}`
                              : `view ${hdCurCode?.value}`}
                          </CustomButtonSmall>
                        )}

                        <span className="panel-card__currency">
                          {figuresToShow === "org" ? hdCurCode?.value : currentUser?.currency_code_xx}
                        </span>
                      </div>
                      <div className="panel-card__divider" />
                    </div>

                    <div className="panel-card__body">
                      <div className="kv-row">
                        <span className="kv-key">{t("paymentAmount").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? hdFcAmount
                              : hdLcAmount
                          ).format("0,0.00")}
                        </span>
                      </div>
                      <div className="kv-row">
                        {figuresToShow === "org" &&
                          hdFcAmount && (
                            <span className="amount-to-words">{`${hdCurCode?.value
                              } ${numberToWordsWithDecimal(hdFcAmount)}`}</span>
                          )}
                        {figuresToShow !== "org" &&
                          hdLcAmount && (
                            <span className="amount-to-words">{`${currentUser?.currency_code_xx
                              } ${numberToWordsWithDecimal(hdLcAmount)}`}</span>
                          )}
                      </div>
                      <div className="kv-row">
                        <span className="kv-key">{t("allocated").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? allocatedFcAmountXx
                              : allocatedLcAmountXx
                          ).format("0,0.00")}
                        </span>
                      </div>

                      <div className="kv-row">
                        <span className="kv-key">{t("osToAllocate").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? formatStringToNumberV2(hdFcAmount) - allocatedFcAmountXx
                              : hdLcAmount - allocatedLcAmountXx
                          ).format("0,0.00")}
                        </span>
                      </div>

                      {/* TOTAL PREMIUM pill (moved from inline styles to SCSS) */}
                      {/* <div className="pill-row pill-row--success">
                        <span className="pill-label">{t("totalPremium").toUpperCase()}</span>
                        <span className="pill-value">
                          {numeral(
                            figuresToShow === "org"
                              ? hdFcAmount
                              : hdLcAmount
                          ).format("0,0.00")}
                        </span>
                      </div> */}
                    </div>
                  </div>
                  <div className="panel-card">
                    <div className="panel-card__header">
                      <div className="panel-card__titleRow">
                        <h1 className="panel-card__title">{t("timeline").toUpperCase()}</h1>
                      </div>
                      {/* <div className="panel-card__divider" /> */}
                      <div className="timeline-root">
                        {traceData.map((item) => (
                          <div key={item?._id} className="timeline-item">
                            <div className="timeline-separator">
                              <div className="timeline-dot"></div>
                              <div className="timeline-connector" />
                            </div>
                            <div className="timeline-content">
                              <div className="timeline-navbar">
                                <div className="avatar-container">
                                  {item?.updated_by_photo_url_xx ?
                                    <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" />
                                    : <InitialsAvatar
                                      name={item?.updated_by_name_xx}
                                      size={30}
                                      currentTheme={currentTheme}
                                    />}
                                  <span className="username">{item?.updated_by_name_xx}</span>
                                </div>
                                <span className="time-ago">{item?.time_ago_xx}</span>
                              </div>
                              <div className="remarks">
                                {item?.trc_remarks}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        )}
        <Collaborator
          open={isCollabOpen}
          docType={"Payment"}
          docNo={hdNo}
          docId={paymentData?._id}
          currentTheme={currentTheme}
          onClose={closeCollab}
          rightOffset={collabRightOffset}
          currentUser={currentUser}
        />
      </div>
      {validationMsgDialog && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-content">
              <ValidationMessages
                messageData={validationMessagesResult}
                onClose={() => setValidationMsgDialog(false)}
                onFix={(row) => {/* focus field / navigate */ }}
                onRemind={() => setValidationMsgDialog(false)}
                onSupport={() => navigate("/support")}
              />
            </div>
          </div>
        </motion.div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notifyDialogText) }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            endIcon={<IoClose />}
            onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(objectToAction.action_text) }} />
        }
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
            <ScaleLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>)}
      {/* email component */}
      {emailDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span>{t('email').toUpperCase()}</span>
              <CircularButton currentTheme={currentTheme} onClick={() => setEmailDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} />
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports').toUpperCase()}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroup={paymentData?.report_group}
                documentData={{
                  docNo: hdNo,
                  docType: "Payment",
                  docId: paymentDocId,
                  payment_docid: paymentDocId,
                  clientEmail: paymentData?.client_details_xx?.ent_email || hdMiscEmail,
                  clientPhoneNo: paymentData?.client_details_xx?.ent_phone_no || hdMiscPhone,
                  clientEntCode: hdEntCode?.value,
                  clientEntName: hdEntCode?.label?.props?.children[0]
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isSearchDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper" style={{ width: "900px", maxWidth: "1100px" }}>
            <div className="overlay-navbar">
              <h1 className="main-title">{t('claims').toUpperCase()}</h1>
              <CircularButton currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setEntityClaims([]);
                    setSearchTermClaim("");
                    setIsSearchDialogOpened(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                          <span>NO</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                          <div className="search-input-wrapper" style={{ width: "300px" }} >
                            <FiSearch className="search-input-icon" />
                            <input
                              className="search-input"
                              type="text"
                              placeholder="Search claim..."
                              value={searchTermClaim}
                              onChange={(e) => setSearchTermClaim(e.target.value)}
                            // onKeyDown={(e) => {
                            //   if (e.key === 'Enter') handleSearchClaims();
                            // }}
                            />
                            {searchTermClaim?.length > 0 && (
                              <MdClose
                                onClick={async (e) => {
                                  try {
                                    setSearchTermClaim("");
                                    await fetchClaims();
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                className="search-input-icon"
                              />
                            )}
                            {searchTermClaim?.length === 0 && (
                              <span className="search-input-icon" />
                            )}
                          </div>
                        </TableCell>
                        <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                          <span>{t('approved')} {currentUser?.currency_code_xx}</span>
                        </TableCell>
                        <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                          <span>{t('paid')} {currentUser?.currency_code_xx}</span>
                        </TableCell>
                        <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                          <span>{t('os')} {currentUser?.currency_code_xx}</span>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                          <span>{t('action')}</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {paginatedClaims?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedClaim?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => {
                            try {
                              setSelectedClaim(row);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentClaimPage * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                            <span className="sub-title">{row?.cm_no}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                              <div className='current-user-avatar'>
                                <div className="user-wrapper">
                                  {row?.facility_details_xx?.ent_photo_url ?
                                    <img src={row?.client_details_xx?.ent_photo_url}
                                      alt="" className='avatar' />
                                    :
                                    <InitialsAvatar
                                      name={row?.client_details_xx?.ent_name}
                                      size={30}
                                      currentTheme={currentTheme}
                                    />
                                  }
                                  <div className="user-org-view">
                                    <span className="sub-title">
                                      {row?.client_details_xx?.ent_name}
                                    </span>
                                    <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                      <MdOutlineNumbers className="icon" />
                                      <h1 className="sub-title xrsmall">{row?.client_details_xx?.ent_code}</h1>
                                      <h1 className="sub-title xrsmall">{`VISIT : ${row?.formatted_visit_xx}`}</h1>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                            <span className="sub-title">{numeral(row?.approved_amount_xx).format("0,0.00")}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                            <span className="sub-title">{numeral(row?.paid_amount_fc_xx).format("0,0.00")}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                            <span className="sub-title">{numeral(parseFloat(row?.approved_amount_xx) - parseFloat(row?.paid_amount_fc_xx)).format("0,0.00")}</span>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                            <CircularButton currentTheme={currentTheme}
                              onClick={async () => {
                                try {
                                  const osAmount = parseFloat(row?.approved_amount_xx) - parseFloat(row?.paid_amount_fc_xx);
                                  const res = await newRequest.post("/apPaymentLn/add", {
                                    ln_hd_no: hdNo,
                                    ln_hd_no_docid: paymentData._id,
                                    ln_doc_type: "AllClaim",
                                    ln_doc_no: row?.cm_no,
                                    ln_doc_docid: row?._id,
                                    ln_hd_status: hdStatus,
                                    ln_paying_for: hdPayingFor?.value,
                                    ln_doc_ins_no: 1,
                                    ln_fc_amount: osAmount,
                                    ln_lc_amount: osAmount,
                                    ln_doc_amount_fc: osAmount,
                                    ln_doc_amount_lc: osAmount,
                                    ln_ent_code: hdEntCode?.value,
                                    ln_comm_fc: 0,
                                    ln_comm_lc: 0,
                                    ln_narration: "Matched"
                                  },);


                                  if (res.data.msg === "exists") {
                                    showToast(
                                      `Document ${row?.cm_no} already attached`,
                                      "error"
                                    );
                                  } else if (res.data?.msg === "added") {
                                    setPaymentLines((prev) => [...prev, res.data?.doc]);
                                    // add to the payment amount
                                    setHdFcAmount((prevAmount) => parseFloat(prevAmount || 0) + osAmount);
                                    showToast("Added!", "success");
                                  } else {
                                    showToast("Error adding claim!", "error");
                                  }

                                } catch (error) {
                                  console.log(error);
                                }
                              }} icon={<IoCheckmarkDoneOutline />} width={"35px"} height={"35px"} />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {entityClaims?.length >
                    rowsPerPageClaims &&
                    <TablePagination
                      rowsPerPageOptions={[5]}
                      rowsPerPage={rowsPerPageClaims}
                      onRowsPerPageChange={handleClaimRowsPerPage}
                      component="div"
                      count={entityClaims?.length}
                      rows={entityClaims}
                      page={currentClaimPage}
                      onPageChange={handleClaimPageChange}
                    />}
                </TableContainer>
              </div>
            </div>
          </div>
        </motion.div>
      )}
      {/* {isConfettiActive && <Confetti />} */}
    </motion.div >
  );
};


export default ApPayment;
